import { render, staticRenderFns } from "./portal.vue?vue&type=template&id=76d3130b&scoped=true&"
import script from "./portal.vue?vue&type=script&lang=js&"
export * from "./portal.vue?vue&type=script&lang=js&"
import style0 from "./portal.vue?vue&type=style&index=0&id=76d3130b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d3130b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppDrawer: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/app/Drawer.vue').default,AppHeader: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/app/Header.vue').default,Spinner: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Spinner.vue').default})
